import { render } from "./PaymentProcess.vue?vue&type=template&id=6049e164"
import script from "./PaymentProcess.vue?vue&type=script&lang=js"
export * from "./PaymentProcess.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__